const prependBase64Content = (content, mimeType = 'image/jpeg') =>
  `data:${mimeType};base64,${content}`;

export { prependBase64Content };
